<template>
  <v-app-bar color="primary" dark app class="app-bar-gradient">
    <v-app-bar-nav-icon
      @click.stop="drawerOpen = !drawerOpen"
    ></v-app-bar-nav-icon>
    <v-app-bar-title>
      <div id="app_bar_title">CVAS AgriLIMS</div>
    </v-app-bar-title>
    <v-spacer></v-spacer>
    <template>
      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              v-bind="attrs"
              v-on="on"
              style="background-color: transparent; 
              border: none;
              box-shadow: none;
              text-transform: none;"
              class="dropdown-btn"
            >
              {{ user?.username }}
              <span
                style="margin-left: 8px;
                margin-top: -8px;
                font-size: initial;"
                >{{ "\u2304" }}</span
              >
            </v-btn>
          </template>
          <v-list>
            <v-list-item key="help" style="cursor: pointer;">
              <v-list-item-icon>
                <img src="@/assets/40-User.png" alt="Help Icon" />
              </v-list-item-icon>
              <div>
                <h4
                  style="font-size: 16px; 
                    font-weight: 400;"
                >
                  {{ user?.username }}
                </h4>
                <span
                  style="font-size: 14px; 
                      font-weight: 400; 
                      color: #868686;"
                  >{{ user?.email }}</span
                >
              </div>
            </v-list-item>
            <!-- <v-list-item key="help" style="cursor: pointer;">
              <v-list-item-icon>
                <img src="@/assets/Vector.png" alt="Help Icon" />
              </v-list-item-icon>
              <v-list-item-title>Help Center</v-list-item-title>
            </v-list-item>
            <v-list-item key="settings" style="cursor: pointer;">
              <v-list-item-icon>
                <img src="@/assets/settings.png" alt="settings icon" />
              </v-list-item-icon>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item> -->
            <v-divider
              style="width: 88%; text-align: center; display: flex; margin: auto; color: #000 !important;"
            ></v-divider>
            <LogoutMenuModal />
          </v-list>
        </v-menu>
      </div>
    </template>
    <Toolbox v-if="developmentMode" />
  </v-app-bar>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapState } from "vuex";
import LogoutMenuModal from "../auth/LogoutMenuModal.vue";
import Toolbox from "@/components/_dev/Toolbox";

export default {
  name: "AppBar",
  components: { LogoutMenuModal, Toolbox },
  computed: {
    ...mapFields(["navigation.drawerOpen"]),
    developmentMode() {
      return process && process.env && process.env.NODE_ENV === "development";
    },
    ...mapState("auth", ["user"])
  }
};
</script>

<style scoped>
.app-bar-gradient {
  background: rgb(22, 105, 65);
  background: linear-gradient(90deg, rgb(22, 105, 65) 0%, rgb(11, 55, 34) 100%);
}
</style>
